import axiosInstance from "@/plugins/axios";
import { ref } from "vue";

export interface IFaqMergedCategory {
    id: string;
    name: string;
    description?: string;
}


export const getRootTranslationCategories = async (langId: string) => {
  const res = await axiosInstance.get(`/translations/${langId}/faqCategories`)
    return res.data
}


export const saveCategoryTranslation = async (langId: string, categoryId: string, translation: string) => {
    
    const res = await axiosInstance.post(`/translations/${langId}/faqCategories/${categoryId}`, { translation })
    return res.data
}

export const getFaqsByLangId = async (langId: string) => {
    const res = await axiosInstance.get(`/translations/${langId}/faqs`)
        return res.data
}

export const getCombinedFaqs = async (langId: string): Promise<Map<string, any>> => {
    try {
        const [faqData, translationData] = await Promise.all([
            axiosInstance.get('/faq'),
            axiosInstance.get('/translations/' + langId),
        ]);

        const translationMap = new Map<string, any>(
            Object.entries(translationData.data.faqs).map(([key, value]) => [
                key,
                value,
            ])
        );

        const combinedFaqs = new Map<string, any>(
            faqData.data.map((faq) => {
                const translation = translationMap.get(faq._id);
                return [
                    faq._id,
                    {
                        ...faq,
                        ...(translation || {}),
                    },
                ];
            })
        );


        return combinedFaqs;
    } catch (err) {
        console.error('Error fetching and combining FAQ:', err);
        return new Map(); // Gib eine leere Map zurück im Fehlerfall
    }
};


export const strippedHtml =(htmlText: string) => {
    const regex = /(<([^>]+)>)/ig;    
	return htmlText.replace(regex, "");
}


export const saveFaqTranslation = async (langId: string, faqId: string, translation: string) => {    
    const res = await axiosInstance.post(`/translations/${langId}/faqs/${faqId}`, { translation })
    return res.data
}